import { RESET_FILTER_CONFIG, SET_FILTER_CONFIG } from '../../constants';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER_CONFIG:
      return action.payload;
    case RESET_FILTER_CONFIG:
      return [];
    default:
      return state;
  }
};
